export function setApplicantProfileUser (state, { applicantProfileUser }) {
  state.applicantProfileUser = applicantProfileUser
}
